module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "xxxstyle": "max-width:100%"
    }
  }, [_c('div', {
    ref: "diagram"
  }, [_vm._l((_vm.groups), function(group, groupIndex) {
    return _c('div', {
      key: groupIndex,
      staticClass: "diagram-group",
      staticStyle: {
        "position": "relative"
      }
    }, [_c('div', {
      staticStyle: {
        "position": "absolute",
        "right": "-11px",
        "top": "-11px",
        "background-color": "white"
      }
    }, [_c('v-menu', {
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({
            attrs: {
              "color": "primary"
            }
          }, on), [_vm._v("add_circle")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.editLoan(null, null, groupIndex)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Add loan")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.editProperty(null, null, groupIndex)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Add property")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": _vm.addGroup
      }
    }, [_c('v-list-item-title', [_vm._v("Add group")])], 1), _vm._v(" "), (_vm.groups.length > 1) ? _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.removeGroup(groupIndex)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Remove group")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": _vm.copyToClipboard
      }
    }, [_c('v-list-item-title', [_vm._v("Copy to Clipboard")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          _vm.wordWrap = !_vm.wordWrap
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Word Wrap")]), _vm._v(" "), (_vm.wordWrap) ? _c('v-icon', [_vm._v("check")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_vm._l((group.loans), function(loan, loanIndex) {
      return _c('div', {
        key: loanIndex,
        class: _vm.loanClass(loan),
        staticStyle: {
          "display": "flex"
        },
        style: ({
          'flex-basis': loan.meta.width + '%',
          'flex-shrink': loan.meta.width
        }),
        on: {
          "click": function($event) {
            return _vm.editLoan(loan, loanIndex, groupIndex)
          }
        }
      }, [_c('div', {
        staticStyle: {
          "flex-grow": "1"
        }
      }, [_c('span', {
        staticClass: "amount"
      }, [_vm._v(_vm._s(_vm._f("thousands")(loan.meta.amountTotal)))]), _vm._v("\n                        " + _vm._s(_vm.loanDescription(loan)) + "\n                    ")])])
    }), _vm._v(" "), _c('v-menu', {
      attrs: {
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('div', _vm._g({
            staticClass: "diagram-space diagram-bar",
            style: ({
              'flex-basis': (100 - group.lvr) + '%'
            })
          }, on), [_vm._v(_vm._s(group.lvr) + "%")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.adjustLVR(92, groupIndex)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("92%")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.adjustLVR(90, groupIndex)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("90%")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.adjustLVR(88, groupIndex)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("88%")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.adjustLVR(85, groupIndex)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("85%")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.adjustLVR(80, groupIndex)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("80%")])], 1)], 1)], 1)], 2), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, _vm._l((group.properties), function(property, propertyIndex) {
      return _c('div', {
        key: propertyIndex,
        class: _vm.propertyClass(property),
        style: ({
          'flex-basis': property.meta.width + '%'
        }),
        on: {
          "click": function($event) {
            return _vm.editProperty(property, propertyIndex, groupIndex)
          }
        }
      }, [_vm._v("\n                    " + _vm._s(_vm._f("thousands")(property.value)) + "\n                    "), (property.address && _vm.$vuetify.breakpoint.mdAndUp) ? _c('span', {
        staticStyle: {
          "color": "rgba(255, 255, 255, 0.7)"
        }
      }, [_vm._v(" - " + _vm._s(property.address))]) : _vm._e(), _vm._v(" "), (property.existing) ? _c('span', [_vm._v(" (Existing)")]) : _vm._e()])
    }), 0)])
  }), _vm._v(" "), _c('div', [_vm._l((_vm.summary), function(attribute) {
    return [(_vm.isPositiveAmount(attribute.value)) ? _c('v-chip', {
      key: attribute.name,
      staticClass: "attribute-chip mt-1 mr-1 grey--text text--darken-1",
      class: {
        selected: attribute == _vm.selectedAttribute
      },
      attrs: {
        "title": attribute.name,
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.selectAttribute(attribute)
        }
      }
    }, [_vm._v(_vm._s(attribute.title) + ": " + _vm._s(_vm._f("currency")(attribute.value)))]) : _vm._e()]
  })], 2)], 2), _vm._v(" "), _c('DialogBox', {
    attrs: {
      "title": "Loan Details",
      "settings": _vm.loanDialog.settings,
      "save-on-enter": ""
    },
    on: {
      "save": function($event) {
        return _vm.saveLoan(_vm.loanDialog.loan)
      }
    }
  }, [_c('div', {
    staticClass: "pa-4"
  }, [_c('div', {
    staticClass: "blue--text text--darken-2",
    staticStyle: {
      "margin-top": "-15px"
    },
    style: ({
      'visibility': _vm.activeLoanPayment ? 'visible' : 'hidden'
    })
  }, [(_vm.loanDialog.loan.io) ? _c('span', [_vm._v("IO ")]) : _vm._e(), _vm._v("\n                Repayment " + _vm._s(_vm._f("currency")(_vm.activeLoanPayment)) + "pm\n                 | " + _vm._s(_vm._f("currency")(_vm.activeLoanPayment * 12 / 52)) + "pw\n\n            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('currency-box', {
    ref: "focus",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "Base Amount"
    },
    model: {
      value: (_vm.loanDialog.loan.amount),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "amount", _vm._n($$v))
      },
      expression: "loanDialog.loan.amount"
    }
  }), _vm._v(" "), _c('v-select', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "items": _vm.lmiOptions,
      "label": "LMI"
    },
    model: {
      value: (_vm.loanDialog.loan.lmiType),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "lmiType", $$v)
      },
      expression: "loanDialog.loan.lmiType"
    }
  }), _vm._v(" "), _c('currency-box', {
    attrs: {
      "label": "Est LMI"
    },
    model: {
      value: (_vm.loanDialog.loan.lmi),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "lmi", _vm._n($$v))
      },
      expression: "loanDialog.loan.lmi"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "Rate %"
    },
    model: {
      value: (_vm.loanDialog.loan.rate),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "rate", _vm._n($$v))
      },
      expression: "loanDialog.loan.rate"
    }
  }), _vm._v(" "), _c('v-select', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "items": _vm.yearsOptions,
      "label": "Years"
    },
    model: {
      value: (_vm.loanDialog.loan.years),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "years", $$v)
      },
      expression: "loanDialog.loan.years"
    }
  }), _vm._v(" "), _c('currency-box', {
    attrs: {
      "label": "New Money (if different)"
    },
    model: {
      value: (_vm.loanDialog.loan.newMoney),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "newMoney", $$v)
      },
      expression: "loanDialog.loan.newMoney"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Package"
    },
    model: {
      value: (_vm.loanDialog.loan.package),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "package", $$v)
      },
      expression: "loanDialog.loan.package"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "label": "Special"
    },
    model: {
      value: (_vm.loanDialog.loan.special),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "special", $$v)
      },
      expression: "loanDialog.loan.special"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "label": "Investment"
    },
    model: {
      value: (_vm.loanDialog.loan.investment),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "investment", $$v)
      },
      expression: "loanDialog.loan.investment"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "label": "Existing Debt Keeping"
    },
    model: {
      value: (_vm.loanDialog.loan.existing),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "existing", $$v)
      },
      expression: "loanDialog.loan.existing"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-select', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "items": _vm.fixedOptions,
      "item-text": "display",
      "item-value": "years",
      "label": (_vm.loanDialog.loan.fixed ? 'Fixed Period' : 'Fixed or Variable')
    },
    model: {
      value: (_vm.loanDialog.loan.fixed),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "fixed", _vm._n($$v))
      },
      expression: "loanDialog.loan.fixed"
    }
  }), _vm._v(" "), (_vm.loanDialog.loan.fixed) ? _c('div', {
    staticStyle: {
      "flex-basis": "180px"
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Rate Lock"
    },
    model: {
      value: (_vm.loanDialog.loan.rateLock),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "rateLock", $$v)
      },
      expression: "loanDialog.loan.rateLock"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.ioOptions,
      "item-text": "display",
      "item-value": "years",
      "label": (_vm.loanDialog.loan.io ? 'Interest Only Period' : 'P&I or IO')
    },
    model: {
      value: (_vm.loanDialog.loan.io),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "io", _vm._n($$v))
      },
      expression: "loanDialog.loan.io"
    }
  })], 1), _vm._v(" "), _c('div', [_c('v-text-field', {
    attrs: {
      "label": "Product",
      "hint": "Include any offers or rebates"
    },
    model: {
      value: (_vm.loanDialog.loan.product),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "product", $$v)
      },
      expression: "loanDialog.loan.product"
    }
  })], 1)]), _vm._v(" "), (_vm.allowDeleteLoan(_vm.loanDialog.loan)) ? _c('DeleteButton', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "slot": "footer"
    },
    on: {
      "delete": function($event) {
        return _vm.deleteLoan(_vm.loanDialog.loan)
      }
    },
    slot: "footer"
  }) : _vm._e()], 1), _vm._v(" "), _c('DialogBox', {
    attrs: {
      "title": "Propety Details",
      "settings": _vm.propertyDialog.settings,
      "save-on-enter": ""
    },
    on: {
      "save": function($event) {
        return _vm.saveProperty(_vm.propertyDialog.model)
      }
    }
  }, [_c('div', {
    staticClass: "pa-4"
  }, [_c('currency-box', {
    ref: "focus",
    attrs: {
      "label": "Value"
    },
    model: {
      value: (_vm.propertyDialog.model.value),
      callback: function($$v) {
        _vm.$set(_vm.propertyDialog.model, "value", _vm._n($$v))
      },
      expression: "propertyDialog.model.value"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Investment"
    },
    model: {
      value: (_vm.propertyDialog.model.investment),
      callback: function($$v) {
        _vm.$set(_vm.propertyDialog.model, "investment", $$v)
      },
      expression: "propertyDialog.model.investment"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "label": "Existing"
    },
    model: {
      value: (_vm.propertyDialog.model.existing),
      callback: function($$v) {
        _vm.$set(_vm.propertyDialog.model, "existing", $$v)
      },
      expression: "propertyDialog.model.existing"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Address"
    },
    model: {
      value: (_vm.propertyDialog.model.address),
      callback: function($$v) {
        _vm.$set(_vm.propertyDialog.model, "address", $$v)
      },
      expression: "propertyDialog.model.address"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.propertyTypes,
      "label": "Type"
    },
    model: {
      value: (_vm.propertyDialog.model.type),
      callback: function($$v) {
        _vm.$set(_vm.propertyDialog.model, "type", $$v)
      },
      expression: "propertyDialog.model.type"
    }
  })], 1), _vm._v(" "), (_vm.allowDeleteProperty(_vm.propertyDialog.model)) ? _c('DeleteButton', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "slot": "footer"
    },
    on: {
      "delete": function($event) {
        return _vm.deleteProperty(_vm.propertyDialog.model)
      }
    },
    slot: "footer"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9d0c018"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/LoanDiagram.vue
// module id = 2664
// module chunks = 1